import React, { useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { postt } from '../ApiSeervice';
import { useHistory } from 'react-router-dom';
import {
  Button,
  Checkbox,
  DatePicker,
  Form,
  Input,
  message,
  Spin,
  Upload,
  InputNumber
} from 'antd';
  import '../../App.css'
const { RangePicker } = DatePicker;
const { TextArea } = Input;





const normFile = e => {
  if (Array.isArray(e)) {
    return e;
  }
  return e === null || e === void 0 ? void 0 : e.fileList;
};



const AddProject = () => {

  const [loading, setLoading] = useState(false);

  const navigate = useHistory();

  const onFinish = async values => {
    setLoading(true); // loading başlat
    console.log('Received values of form: ', values);
    const formData = new FormData();

    formData.append('Place', values.place);
    formData.append('ProjectArea', values.projectArea);
    formData.append('StartDate', values.StartDate.format('YYYY-MM-DD')); // ISO formatında gönder
    formData.append('Duration', values.duration);
    formData.append('Title', values.title);
    formData.append('Description', values.description);
    formData.append('Type', values.type);

    values.photos.forEach(photo => {
      formData.append('Files', photo.originFileObj);

    });


    try {
  
      let response = await postt(formData);
      console.log(response);
      if (response.status === 200) {
        message.success('Proje başarıyla eklendi');
        navigate.push('/panel-options');
      } else {
        message.error('Proje eklenemedi');
      }
    } catch (error) {
      message.error('Bir hata oluştu. Lütfen tekrar deneyin.');
      console.error(error);
    } finally {
      setLoading(false); // loading durdur
    }
  };



  return (
    <>
      <h1 style={{ marginLeft: "2vw" }}>Proje Ekle </h1>
      <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', marginTop: '50px' }}>
        <Spin spinning={loading}>
          <Form
          
      
          
        labelCol={{ span: 5 }}
        // wrapperCol={{ span: 32 }}
            onFinish={onFinish}
      className='form'

          >


            <Form.Item label="Başlık" name="title" rules={[{ required: true, message: 'Proje Başlığı Boş Olamaz' }]}>
              <Input />
            </Form.Item>


            <Form.Item label="Yer" name="place" rules={[{ required: true, message: 'Proje Yeri Boş Olamaz' }]}>
              <Input />
            </Form.Item>



            <Form.Item label="Tür" name="type" rules={[{ required: true, message: 'Proje Türü Boş Olamaz' }]}>
              <Input />
            </Form.Item>

            {/* <Form.Item label="Kategori">
            <Select>
              <Select.Option >df</Select.Option>
            </Select>
          </Form.Item> */}

            <Form.Item label="Proje alanı" name="projectArea" rules={[{ required: true, message: 'Proje Alanı Boş' }]}>
              <InputNumber />
            </Form.Item>


            <Form.Item label="Başlangıç tarihi" name="StartDate" rules={[{ required: true, message: 'Proje Başlangıç Tarihi Boş Olamaz' }]}>
              <DatePicker format="YYYY-MM-DD" />
            </Form.Item>

            <Form.Item label="Süre" name="duration" rules={[{ required: true, message: 'Proje Alanı Boş Olamaz' }]}>
              <Input />
            </Form.Item>


            <Form.Item label="Acıklama" name="description" rules={[{ required: true, message: 'Proje Açıklaması Boş Olamaz' }]}>
              <TextArea rows={4} />
            </Form.Item>

            <Form.Item label="Resimler" name="photos" valuePropName="fileList" getValueFromEvent={normFile} rules={[{ required: true, message: 'Proje Resimleri Boş Olamaz' }]}>
              <Upload listType="picture-card" accept="image/*"  >
                <button
                  style={{ color: 'inherit', cursor: 'inherit', border: 0, background: 'none' }}
                  type="button"
                >
                  <PlusOutlined />
                </button>
              </Upload>
            </Form.Item>


            <div style={{ display: 'flex', justifyContent: "space-evenly" }}>
              <Form.Item  >
                <Button htmlType="submit" style={{ textTransform: 'none' }} >Tamam</Button>
              </Form.Item>


            </div>

          </Form>
        </Spin>
      </div>

    </>

  );
};
export default AddProject;